import type { ComponentProps } from "react";
import BaseActionButton from "./BaseActionButton";

type NextButtonProps = Omit<
    ComponentProps<typeof BaseActionButton>,
    "iconType" | "testId" | "buttonType" | "label" | "loadingText"
> & {
    label?: string;
    loadingText?: string;
};

const NextButton = ({ onClick, label = "Next", loadingText, ...props }: NextButtonProps = {}) => {
    return (
        <BaseActionButton
            label={label}
            loadingText={loadingText ?? label}
            iconType="next"
            testId="next-button"
            buttonType={onClick ? "button" : "submit"}
            onClick={onClick}
            {...props}
        />
    );
};

export default NextButton;
